import React from "react";


const ReleaseNote = () => {
  

    const tableStyle = {
        borderCollapse: "collapse",
      };
      
      const thTdStyle = {
        border: "1px solid gray",
        padding: "8px",
        textAlign: "left",
      };
      
      const headerStyle = {
        fontWeight: "bold",
        backgroundColor: "#f2f2f2",
      };
  return (
    <>
        <div className="release-note-block">
        <h1>Content Casting Releases</h1>
        <table style={tableStyle}>
        <tbody>
          <tr>
            <td colSpan="2" style={{ ...thTdStyle, ...headerStyle }}>
              Version 1.3.0
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Task Id: 1</td>
            <td style={thTdStyle}>
              <ul>
                <li>Implements Base Functionalities</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ ...thTdStyle, ...headerStyle }}>
              Version 1.3.0
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Task Id: 2</td>
            <td style={thTdStyle}>
              <ul>
                <li>Implements incident menagement upload report, download report, dashboard</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Task Id: 17749</td>
            <td style={thTdStyle}>
              <ul>
                <li>No validation msg for incorrect file format</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ ...thTdStyle, ...headerStyle }}>
              Version 1.4.0
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Task Id: 18277</td>
            <td style={thTdStyle}>
              <ul>
                <li>A "Delete" button will be added to the Operations column, alongside the existing "Edit User". </li>
                <li>Add Hotel Room count field add, STB count field add, Room number field add, document field add.</li>
                <li>Same as Add hotel and fetch data added field.</li>
                <li>Usage Report Daily and weekly date select functionlity add on login type admin.</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Task Id: 18570</td>
            <td style={thTdStyle}>
              <ul>
                <li>inc. pdf should be below 20Mb on analytics Portal</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td style={thTdStyle}>Bug Id: 18382</td>
            <td style={thTdStyle}>
              <ul>
                <li>Download pdf is wrongly displayed</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </>
  );
};

export default ReleaseNote;
